import { useAdminDeliveryProposalCreatePageProps } from "./fetch";
import { AdminDeliveryProposalCreatePageUi } from "./ui";

export const AdminDeliveryProposalCreatePage: React.FC<{
  offerCargoIdStr: string | undefined;
}> = (params) => {
  const props = useAdminDeliveryProposalCreatePageProps(params.offerCargoIdStr);
  return <AdminDeliveryProposalCreatePageUi {...props} />;
};
